import Blocks from "@/components/Blocks"

export default function TextBlockBody({ block }) {
  if (block.innerBlocks.length === 0) {
    return null
  }

  const settings = {
    "core/buttons": { width: "bleed" },
    "core/heading": { width: "bleed" },
    "core/paragraph": { width: "bleed" },
    "core/list": { width: "bleed" }
  }

  return (
    <div className="body">
      <Blocks blocks={block.innerBlocks} settings={settings} />
    </div>
  )
}
